import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserResponse, User } from '../models';
import { Guid } from '@fitscovery/common/types';
import { APP_ENVIRONMENT } from '../environment-injection';
import { Environment } from '@fitscovery/common/environments';

@Injectable()
export class ApiUsersService {

  constructor(
    private http: HttpClient,
    @Inject(APP_ENVIRONMENT) private env: Environment,
  ) {}

  createUser(user: any): Observable<UserResponse> {
    return <Observable<UserResponse>>this.http.post(`${this.env.nodeApi.users}/users`, user);
  }

  getUsers(): Observable<UserResponse> {
    return <Observable<UserResponse>>this.http.get(`${this.env.nodeApi.users}/users?roleId=3`);
  }

  getUserByEmail(email: string): Observable<UserResponse> {
    return <Observable<UserResponse>>this.http.get(`${this.env.nodeApi.users}/users?email=${email}`);
  }

  deleteUser(id: Guid): Observable<UserResponse> {
    return <Observable<UserResponse>>this.http.delete(`${this.env.nodeApi.users}/users/${id.toString()}/roles/${3}`);
  }

  async getBackOfficeUser(): Promise<User> {
    return this.http.get(`${this.env.nodeApi.users}/v1/backoffice-auth/me`).toPromise().then((response: any) => {
      return response.backofficeUser
    });
  }
}
